import { logger } from "@masterkey/logger";
import { createClient } from "@masterkey/supabase/client";

export async function getUser() {
  const supabase = createClient();

  try {
    const result = await supabase.auth.getUser();

    return result;
  } catch (error) {
    logger.error(error);

    throw error;
  }
}

export async function getSession() {
  const supabase = createClient();

  try {
    const result = await supabase.auth.getSession();

    return result;
  } catch (error) {
    logger.error(error);

    throw error;
  }
}

export async function getFileUrl(bucketName: string, filePath: string) {
  const supabase = createClient();

  try {
    const { data } = supabase.storage.from(bucketName).getPublicUrl(filePath);

    return data.publicUrl;
  } catch (error) {
    logger.error(error);
    throw error;
  }
}

export async function isUserPro(userId: string) {
  const supabase = createClient();

  try {
    const { data: result, error } = await supabase
      .from("subscriptions")
      .select()
      .eq("user_id", userId)
      .eq("status", "active")
      .gte("end_date", new Date().toISOString());

    if (error) {
      logger.error(error);
      throw error;
    }

    return result[0];
  } catch (error) {
    logger.error(error);
    throw error;
  }
}
